export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-2.32d15bdd.png";